import React, { useState } from 'react';

import { Grid } from '@progress/kendo-react-grid';
import { process as kendoProcess } from '@progress/kendo-data-query';

const BobTable = ({
    altStyle,
    columns,
    className,
    data,
    isPageable,
    filterable,
    initialDataState,
    scroll = 'scrollable',
    onRowClick,
    ...props
}) => {
    const [dataState, setDataState] = useState({});
    const [pageable] = useState({ pageSizes: true });

    const onDataStateChange = e => {
        setDataState(e.dataState);
    };

    return (
        <React.Fragment>
            {
                altStyle ?
                    <style>
                        {
                            `.k-textbox {
                        font-size: 1.2rem;
                    }
                    .k-numerictextbox {
                        font-size: 1.2rem;
                    }
                    .k-dropdown {
                        font-size: 1.2rem;
                    }
                    .k-grid th, .k-grid td {
                        padding: 0 12px;
                    }
                    .k-grid th:first-child, .k-grid td:first-child {
                        white-space: nowrap;
                        text-overflow: ellipse;
                    }
                    .k-grid thead {
                        background-color: #f4f4f4;
                    }
                    .k-grid tfoot {
                        background-color: #f4f4f4;
                    }
                    `
                        }
                    </style>
                    :
                    <style>
                        {
                            `.k-textbox {
                        font-size: 1.2rem;
                    }
                    .k-numerictextbox {
                        font-size: 1.2rem;
                    }
                    .k-dropdown {
                        font-size: 1.2rem;
                    }
                    `
                        }
                    </style>
            }
            <Grid
                sortable={{
                    mode: 'multiple'
                }}
                className={className}
                data={kendoProcess(data, dataState)}
                {...dataState}
                pageable={isPageable ? pageable : false}
                reorderable
                filterable={filterable ? true : false}
                onRowClick={onRowClick ? onRowClick : null}
                onDataStateChange={onDataStateChange}
                scrollable={scroll ? scroll : 'none'}
            >
                {columns}
            </Grid>
        </React.Fragment>
    );
};

export default BobTable;
